<!--
 * @Author: gaoxueting
 * @Date: 2020-06-03 17:59:08
 * @LastEditTime: 2020-08-11 10:11:56
 * @LastEditors: fengzhongmei
 * @Description:
 * @FilePath: /rightcloud-console2/src/views/modules/cloudmgt/env/components/acl/aclindex.vue
-->
<template>
    <!-- 云环境管理的RDS(详情)组件(阿里云专属) -->
    <div class="layout-rctable-container env-mgtacl"
         style="height: calc(100%);">
        <helpinfo :helpData="helpData"
                  style="position: absolute;">
            <div slot="slotR"
                 class="back-div"
                 @click="$router.go(-1)">
                <Icon type="ios-arrow-dropleft"
                      size="16" />
                <span>{{$t('返回')}}</span>
            </div>
        </helpinfo>
        <div class="table-container"
             style="padding:65px 15px 15px 15px;background:#f5f6f7;width: 100%;height: calc(100% - 1px);overflow-y: auto;"
             v-if="show">
            <Tabs style="min-height: 100%;"
                  v-model="tabName"
                  type="card"
                  class="gray"
                  :animated="false">
                <TabPane :label="$t('概览')"
                         name="detail">
                    <detail v-if="tabName === 'detail'"
                            :id="id"
                            :envId="envId"
                            :envType="envType"
                            :baseInfo="baseInfo"
                            @update="initData"></detail>
                </TabPane>
                <TabPane :label="$t('入方向')"
                         name="inDirection">
                    <aclRule v-if="tabName === 'inDirection'"
                             :id="id"
                             :envId="envId"
                             :envType="envType"
                             type="ingress"
                             :baseInfo="baseInfo"></aclRule>
                </TabPane>
                <TabPane :label="$t('出方向')"
                         name="outDirection">
                    <aclRule v-if="tabName === 'outDirection'"
                             :id="id"
                             :envId="envId"
                             :envType="envType"
                             type="egress"
                             :baseInfo="baseInfo"></aclRule>
                </TabPane>
                <TabPane :label="$t('关联子网')"
                         name="relatedSubnet">
                    <relatedSubnet v-if="tabName === 'relatedSubnet'"
                                   :id="id"
                                   :envId="envId"
                                   :envType="envType"
                                   :baseInfo="baseInfo" />
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>

<script>
import helpinfo from '@c/basic/helpinfo'
import detail from './detail.vue'
import relatedSubnet from './relatedsubnet.vue'
import aclRule from './aclrule.vue'
import API from '@/service/api.js'
export default {
    name: 'rdsdetailindex',
    components: {
        helpinfo,
        detail,
        relatedSubnet,
        aclRule
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('网络ACL') + ' - ' + this.$route.query.name,
                type: ''
            },
            tabName: this.$route.query.tabName || 'detail',
            id: this.$route.params.id || '',
            envId: this.$route.query.envId || '',
            envType: this.$route.query.envType || '',
            baseInfo: {},
            show: false
        }
    },
    created () {
        this.initData()
    },
    watch: {
        '$route' (val) {
            this.initData()
        }
    },
    methods: {
        initData () {
            this.axios.get(this.urlFormat(API.FIREWALL_DELETE, false, [this.id])).then(res => {
                this.baseInfo = res
                this.show = true
            })
        }
    }
}
</script>
<style lang="less" >
.env-mgtacl {
    .rcTable-content {
        table {
            thead {
                th {
                    background: #fff !important;
                }
            }
            tbody {
                td {
                    background: #f5f6f7 !important;
                }
            }
        }
    }
}
</style>
